import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=6d89f02a&scoped=true"
import script from "./dictionary.vue?vue&type=script&lang=ts"
export * from "./dictionary.vue?vue&type=script&lang=ts"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=6d89f02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89f02a",
  null
  
)

export default component.exports